// Mapeamento dos títulos dos itens do checklist para os campos do backend
export const CHECKLIST_FIELD_MAPPING = {
  Abastecimento: 'fuel',
  Hodômetro: 'odometer',
  'Estado Externo do Veículo': 'external_conditions',
  'Estado Interno do Veículo': 'internal_conditions',
  'CNH e documentos': 'documents',
  'Nível de Combustível': 'fuel',
  'Estado dos Pneus': 'tire_conditions',
  'Sistema de Iluminação': 'lighting_system',
  'Sistema de Freios': 'brake_system',
  'Fluidos do Veículo': 'vehicle_fluids',
  Arla: 'arla',
  'Plataforma hidráulica': 'hydraulic_platform',
  'Equipamentos de Segurança': 'safety_equipment',
}

// Mapeamento para o modal de problemas (alguns campos têm nomes diferentes)
export const CHECKLIST_PROBLEM_FIELD_MAPPING = {
  Abastecimento: 'refueling',
  Hodômetro: 'odometer',
  'Estado Externo do Veículo': 'external_conditions',
  'Estado Interno do Veículo': 'internal_conditions',
  'CNH e documentos': 'documents',
  'Nível de Combustível': 'fuel',
  'Estado dos Pneus': 'tire_conditions',
  'Sistema de Iluminação': 'lighting_system',
  'Sistema de Freios': 'brake_system',
  'Fluidos do Veículo': 'vehicle_fluids',
  Arla: 'arla',
  'Plataforma hidráulica': 'hydraulic_platform',
  'Equipamentos de Segurança': 'safety_equipment',
}
